/**
 * O trinco de rolagem do corpo da página (UI-28).
 *
 * ## O defeito
 *
 * **Nenhum dos nove modais de `src/shared/modals/` travava o `body`.** Abrir um modal e rolar movia
 * o conteúdo de trás — e no telefone era pior, porque a rolagem "vazava" do modal para a página
 * assim que o conteúdo dele chegava ao fim.
 *
 * ## Por que `overflow: hidden` sozinho não resolve
 *
 * É a solução que todo mundo tenta primeiro, e **o Safari do iOS a ignora** no `body`. O que
 * funciona nos dois é `position: fixed` — e aí aparece o efeito colateral que faz a maioria das
 * implementações caseiras ser pior que o problema: **fixar o corpo joga a página para o topo.** O
 * jogador abre um modal no fim da lista de peixes, fecha, e está de volta no começo.
 *
 * Por isso o `top: -Ypx` na hora de travar e o `scrollTo` na hora de soltar: a posição é guardada,
 * compensada visualmente enquanto o modal está aberto, e devolvida ao fechar.
 *
 * ## Por que um contador em vez de um booleano
 *
 * Modais se empilham — a Loja abre a confirmação de compra, que abre o aviso de ouro insuficiente.
 * Com um booleano, **fechar o de cima destrava a página com o de baixo ainda aberto**. O contador
 * só solta quando o último fecha.
 */

let abertos = 0;
let posicaoGuardada = 0;

export function travarRolagem() {
  abertos += 1;
  if (abertos > 1) return; // já travado por um modal de baixo

  posicaoGuardada = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.style.top = `-${posicaoGuardada}px`;
  document.body.classList.add('rolagem-travada');
}

export function destravarRolagem() {
  if (abertos === 0) return;

  abertos -= 1;
  if (abertos > 0) return;

  document.body.classList.remove('rolagem-travada');
  document.body.style.top = '';
  // `instant` e não `smooth`: a página não deve rolar visivelmente de volta ao fechar um modal —
  // ela já estava ali. Uma rolagem animada aqui parece que a página se mexeu sozinha.
  window.scrollTo({ top: posicaoGuardada, behavior: 'instant' });
}

/**
 * A saída de emergência, para o caso de o contador desandar (uma troca de rota que desmonta dois
 * modais fora de ordem, um erro no meio de um `aoFechar`). Sem ela, o sintoma é a página que
 * "parou de rolar" e nada na tela explicando por quê — e a única saída seria recarregar.
 */
export function soltarTudo() {
  abertos = 0;
  document.body.classList.remove('rolagem-travada');
  document.body.style.top = '';
}
